import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sl-count-display',
    templateUrl: './count-display.component.html',
    styleUrls: ['./count-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CountDisplayComponent {
    @Input() label: string;
    @Input() amount: number;
    @Input() symbol: string;
    @Input() decimalPlaces?: number = undefined;
}
